<template>

  <div class="no-table-box no-card-base">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="Business Contacts" name="Business Contacts" class="tab-section" v-if="!isResidentialUser">
        <div id="contacts-view">
          <div class="box flex align-center">
            <div class="list-search-input flex align-center" style="width:100%;">
              <div class="box">
                <el-input
                  v-model="search"
                  placeholder="Search Name / Number"
                  clearable>
                  <template slot="prefix">
                    Search
                  </template>
                </el-input>
              </div>
            </div>
          </div>
          <div class="configureMessage" v-if="!userConfigured">
            Your User Extension Has Not Been Configured. See Admin.
          </div>

          <div
            style="height: calc(100vh - 14em); width: 100%;"
          >
            <vxe-grid
              round
              class="user-stats-table vxe-contacts"
              border="inner"
              ref="xGrid"
              height="100%"
              auto-resize
              show-overflow="tooltip"
              empty-text="No Data"
              :data="contactList"
              :scroll-y="{enabled: true, gt: 50, oSize: 0}"
              :loading="contactsLoading"
              :columns="tableColumns">
            </vxe-grid>
          </div>

        </div>
      </el-tab-pane>

      <el-tab-pane label="Personal Contacts" name="Personal Contacts" class="tab-section">
        <div id="personal-contacts-view">
          <div class="box flex align-center" style="width: 100%; justify-content: space-between;">
            <div class="box flex align-center" style="width: 100%;">
              <div class="add-contact-button">
                <el-tooltip content="Add Contacts" placement="top">
                  <el-button
                    type="default"
                    class="table-action-button"
                    icon="el-icon-plus"
                    @click="showModal('Create')">
                  </el-button>
                </el-tooltip>
              </div>
              <el-form class="list-search-input">
                <el-input
                  style="margin-left: 10px; margin-right: 10px;"
                  v-model="searchPersonal"
                  placeholder="Search Name / Number / Company"
                  clearable>
                </el-input>
              </el-form>
              <h4 class="black-text" style="margin-left: 25px;">{{personalContactsCount}} contacts shown</h4>
            </div>
            <el-button class="flex ml-10 hidden-xs-only" @click="doExport" style="justify-content: end;">
              Export
            </el-button>
          </div>
          <div class="configureMessage" v-if="!userConfigured">
            Your User Extension Has Not Been Configured. See Admin.
          </div>
          <div style="height: calc(100vh - 15em); width: 100%;">
            <vxe-grid
              round
              @cell-click="cellClicked"
              class="user-stats-table vxe-contacts"
              border="inner"
              ref="xGrid"
              height="100%"
              auto-resize
              show-overflow="tooltip"
              empty-text="No Data"
              :data="filteredListPersonal"
              :scroll-y="{enabled: true, gt: 50, oSize: 0}"
              :loading="contactsLoading"
              :columns="tableColumnsPersonal">
            </vxe-grid>
          </div>
        </div>
        <contact-form
          :visible="contactModalVisible"
          :context="modalContext"
          :recordId="modalModelId"
          @modalClosed="contactModalVisible = false">
        </contact-form>
      </el-tab-pane>
    </el-tabs>
  </div>


</template>

<script>

  import PersonalContact from "../contacts/components/personal-contact";
  import ContactForm from "../contacts/components/contact-form";
  import {mapGetters} from "vuex";
  import {globalEventBus} from "../../../globalEventBus";
  import debounce from 'lodash/debounce';
  import feathersClient from "@/feathers/feathers-client";
  import {phoneNumberFormatter} from "@/globals/globals";
  import {ExportToCsv} from "export-to-csv";

  export default{
    name: 'MyContacts',
    components: {PersonalContact, ContactForm},
    data(){
      return {
        search: '',
        searchActive: false,
        searchPersonal: '',
        personalContactsLoading: false,
        selectedBranch: null,
        contactsCount: '',
        contactsLoading: false,
        personalContactsCount: '',
        activeTab: 'Business Contacts',
        contactModalVisible: false,
        modalContext: '',
        modalModelId: '',
        userConfigured: true,
        branchOptions: [],
        contactList: [],
        tableColumns: [
          {
            field: 'avatar',
            width: 60,
            showOverflow: true,
            showHeader: false,
            align: 'center',
            slots: {
              default: ({row}) => {
                return [
                  <div>
                    {
                      row.avatarPath
                        ? <div class="contact-avatar">
                          <img src={row.avatarPath} alt={row.name} title={row.name}/>
                        </div>
                        : <div class="contact-avatar">
                          {row.name.substring(0, 1).toUpperCase()}
                        </div>
                    }
                  </div>
                  ]

              }
            }
          },
          {
            field: 'status',
            title: '',
            width: 45,
            slots: {
              default: ({ row }) => {
                return [
                  <status-indicator
                    pulse={false}
                    status={row.onlineStatus ? 'positive': 'negative'}
                  />
                ]
              }
            }
          },
          {
            field: 'name',
            title: 'Name',
            showOverflow: true,
            width: 275,
            sortable: true
          },
          {
            field: 'number',
            title: 'Ext',
            showOverflow: true,
            width: 100,
            sortable: true
          },
          {
            field: 'phoneNumbers',
            title: 'Direct Dials',
            width: 175,
            showOverflow: 'tooltip',
            slots: {
              default: ({row}) => {
                return [
                  <span>{row.phoneNumbers.map(item => this.numberFormatter(item)).join(', ')}</span>
                ]
              }
            }
          },
          {
            field: 'dial',
            width: 75,
            slots: {
              default: ({row}) => {
                return [
                  <el-button
                    class="table-action-button"
                    onClick={() => this.dialCall(row.number)}>
                    <v-svg class="voxo-green" sprite="phone"/>
                  </el-button>
                ]
              }
            }
          },
          {
            field: ''
          }
        ],
        tableColumnsPersonal: [
          {
            field: 'avatar',
            width: 60,
            showOverflow: true,
            showHeader: false,
            align: 'center',
            slots: {
              default: ({row}) => {
                return [
                  <div class="avatar-group" style="width:38px">
                    <div class="contact-avatar">
                      {row.FIRSTNAME.substring(0, 1).toUpperCase()}
                    </div>
                  </div>
                ]
              }
            }
          },
          {
            field: 'FIRSTNAME',
            title: 'Name',
            showOverflow: true,
            sortable: true,
            width: 275,
            slots: {
              default: ({row}) => {
                return [
                  <div clase="contact-info">
                    <div class="contact-name">
                      {row.FIRSTNAME} {row.LASTNAME}
                    </div>
                    <p class="text-muted mb-0 mt-0" style="font-size: 10pt;">{row.COMPANY}</p>
                  </div>
                ]
              }
            }
          },
          {
            field: 'PHONE1',
            title: 'Number',
            showOverflow: true,
            width: 150,
            sortable: true,
            slots: {
              default: ({row}) => {
                return [
                  <span>{this.numberFormatter(row.PHONE1)}</span>
                ]
              }
            }
          },
          {
            field: 'call',
            width: 75,
            slots: {
              default: ({row}) => {
                return [
                  <el-button
                    class="table-action-button"
                    onClick={() => this.dialCall(row.PHONE1)}
                    style="box-shadow: none;">
                  <v-svg class="voxo-green" sprite="phone"/>
                </el-button>
                ]
              }
            }
          },
          {
            field: ''
          }
        ]
      }
    },
    computed: {
      ...mapGetters('phonebook-entries', {getPhonebookEntriesList: 'find'}),
      selectedTenant(){
        return this.$store.getters.selectedTenant;
      },
      softphoneEnabled(){
        return this.$store.state.softphoneEnabled;
      },
      personalContactList(){
        //in case an entry is empty we make sure details exists
        if(this.user.hasOwnProperty('myExtension')){
          const list = this.getPhonebookEntriesList({
            query: {
              hasDetails: true,
              phonebookId: this.user.myExtension.omniaPhonebookId,
              $sort: {
                FIRSTNAME: 1
              }
            }
          }).data;
          this.personalContactsCount = list.length;
          return list;
        }
        return [];
      },
      user(){
        return this.$store.state.auth.user;
      },
      filteredListPersonal(){
        return this.filteredDataPersonal();
      },
      isResidentialUser() {
        if(this.user){
          const {isResidential} = this.user.myExtension;
          if(isResidential){
            this.activeTab = 'Personal Contacts'
            return !!isResidential;
          }
        }
        return false;
      }
    },
    watch: {
      search: debounce(function () {
        this.searchContacts();
      }, 500)
    },
    methods: {
      filteredDataPersonal(){
        const filteredList = this.personalContactList.filter(data => !this.searchPersonal
          || data.FIRSTNAME.toLowerCase().includes(this.searchPersonal.toLowerCase())
          || data.LASTNAME.toLowerCase().includes(this.searchPersonal.toLowerCase())
          || data.PHONE1.toLowerCase().includes(this.searchPersonal.toLowerCase())
          || data.COMPANY.toLowerCase().includes(this.searchPersonal.toLowerCase())
        );
        this.personalContactsCount = filteredList.length;
        return filteredList;
      },
      searchContacts(){
        if(this.search.length){
          this.contactList = this.allContacts.filter(item =>
            item.name.toLowerCase().includes(this.search.toLowerCase())
            || item.number.includes(this.search)
          )
        } else{
          this.contactList = [...this.allContacts];
        }
      },
      showModal(context, editId = null) {
        this.contactModalVisible = true;
        this.modalContext = context;
        this.modalModelId = editId;
      },
      dialCall(number){

        if(this.softphoneEnabled) {
          globalEventBus.$emit('dialSoftphone', number);
        } else {
          const {peerName} = this.user.myExtension;
          feathersClient.service('nats-actions-handler').create({
            reqType: 'notifyOriginate',
            number: number,
            peerName
          });
        }

      },
      numberFormatter(number) {
        return phoneNumberFormatter(number);
      },
      async loadContacts(){

        //if this is a residential user do not load extensions
        const {tenantId, isResidential} = this.user.myExtension;
        if(isResidential){
          this.allContacts = [];
          this.contactList = [];
          return;
        }

        //get the contacts by Branch
        this.contactsLoading = true;
        feathersClient.service('extensions').find({
          query: {
            addState: false,
            queryPhonebook: true,
            excludeNotInPb: true,
            tenantId: this.user.myExtension.tenantId,
          }
        }).then (res => {
          this.allContacts = [...res];
          this.contactList = [...res];
          this.contactsLoading = false;
        });
      },
      cellClicked(data) {
        if(data.column.property !== 'call'){
          this.showModal('Edit', data.row.id);
        }
      },
      doExport(){
        const data = [...this.personalContactList];
        if (data.length){

          const writeData = data.map(item => ({
            firstName: item.FIRSTNAME ? item.FIRSTNAME : '',
            lastName: item.LASTNAME ? item.LASTNAME : '',
            number: item.PHONE1 ? item.PHONE1: '',
            email: item.EMAIL ? item.EMAIL : '',
            company: item.COMPANY ? item.COMPANY: ''
          }));

          const options = {
            filename: "personal_contacts",
            showLabels: true,
            headers: [
              "firstName",
              "lastName",
              "number",
              "email",
              "company"
            ],
          };

          const csvExporter = new ExportToCsv(options);
          csvExporter.generateCsv(writeData);
        }
      },
    },
    created(){
      if(this.user){
        if(!this.user.hasOwnProperty('myExtension')){
          this.$notify({
            title: 'Warning',
            message: 'Your Account Has No Assigned Extension',
            type: 'warning'
          });
          this.userConfigured = false;
        }
      }
    },
    mounted(){
      this.loadContacts();
    }
  }

</script>

<style lang="scss" scoped>

  @import '../../../assets/scss/variables';

  .el-table td{
    padding: 0;
  }

  .contact-item{
    padding: 0;
    min-height: 50px;
  }

  .list-search-input{
    //width: 25%;
    min-width: 300px;
    margin-top: 0px;
    margin-left: 0px !important;
  }

  .el-tabs--top{
    //margin-top: 10px;
    margin-left: 0px !important;
  }

  .card-base, .no-card-base form{
    padding-top: 0px;
  }

  .table-box, .no-table-box{
    height: calc(100% - .7em);
    overflow: hidden;
  }

  #recent-calls-view{
    height: 100%;
  }

  .item-list{
    max-height: calc(100vh - 20em);
    overflow-y: auto;
  }

  .item-list-contacts{
    margin-top: 10px;
    max-height: calc(100vh - 16em);
    overflow-y: auto;
  }

  .add-contact-button{
    text-align: right;
    margin-left: 0px !important;
    .el-button {
      width: 38px;
      height: 38px;
    }
  }

  .inbound-outbound-filter{
    margin-bottom: 20px;
  }

  .tab-label{
    position: relative;
    display: flex;
  }

  .number-badge{
    margin-top: -8px;
  }

  .filter-columns{
    display: flex;
  }

  .filter-checkbox{
    display: block;
  }

  .table-container{
    height: calc(100vh - 14.75em);
  }

  @media (max-width: 959px){
    #recent-calls-view, #contacts-view, #personal-contacts-view{
      .box{
        flex-wrap: wrap;
      }
    }
  }

  @media (max-width: 499px){
    .el-checkbox-group{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .box{
      >*{
        flex-basis: 100%;
      }
      .black-text{
        flex-basis: 100%;
        margin-bottom: 20px;
      }
      .list-search-input{
        margin-left: 10px !important;
      }
      .call-item{
        margin-right: 10px;
      }
    }

    #calls-count{
      text-align:center !important;
    }

    .inbound-outbound-filter{
      display: flex;
      justify-content: center;
    }
  }

</style>
